<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-75">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                                </div>
                                <h4 class="title">Détail du contrat</h4>
                            </div>
                            <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                                <div class="flex items-center justify-end header-actions">
                                    <div class="mr-3">
                                        <md-button class="md-icon-button md-raised md-info"
                                            @mousedown="goToRoute($event, 'Client Details', { id: contract.site.client.id })">
                                            <span class="leading-none font-medium">Client : {{ contract.site.client.name }}</span>
                                        </md-button>
                                    </div>
                                    <div class="mr-3">
                                        <md-button class="md-icon-button md-raised md-info"
                                                   @mousedown="goToRoute($event,'Site Details', { id: contract.site.client.id, idSite: contract.site.id })">
                                            <span class="leading-none font-medium">Site : {{ contract.site.name }}</span>
                                        </md-button>
                                    </div>
                                    <div>
                                        <md-button class="md-icon-button md-raised md-warning"
                                            @mousedown="goToRoute($event,'Contract Edit', { contractId: contract.id })">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Modifier</md-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <contract-informations :contract="contract"></contract-informations>
                    </md-card-content>
                    <md-card-actions v-if="!contract.is_active">
                        <div class="block-alert danger">
                            <p class="font-medium">Le contrat n'est pas actif ! Il n'est donc pas disponible dans la planification des interventions.</p>
                        </div>
                    </md-card-actions>
                </md-card>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fas', 'clipboard-list']" />
                                </div>
                                <h4 class="title">Plan d'intervention</h4>
                            </div>
                            <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                                <div class="flex items-center justify-end header-actions">
                                    <div v-if="!contract.intervention_plan" class="w-auto">
                                        <md-button class="md-icon-button md-raised md-info"
                                                   @mousedown="goToRoute($event,'Intervention Plan Add')">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Ajouter un plan d'intervention</md-tooltip>
                                    </div>
                                    <template v-else>
                                        <div class="flex items-center">
                                            <div v-if="contract.intervention_plan && contract.intervention_plan.is_updating" class="mr-3">
                                                <md-button class="md-icon-button md-raised md-success"
                                                           @click="activateInterventionPlan">
                                                    <font-awesome-icon class="md-icon" :icon="['fa', 'check']" />
                                                </md-button>
                                                <md-tooltip md-direction="top">Utiliser cette version</md-tooltip>
                                            </div>
                                            <div>
                                                <md-button class="md-icon-button md-raised md-warning"
                                                           @mousedown="goUpdateInterventionPlan($event)">
                                                    <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                                </md-button>
                                                <md-tooltip md-direction="top">Modifier le plan d'intervention</md-tooltip>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <template v-if="contract.intervention_plan && contract.intervention_plan.planning_intervention_groups.length > 0">
                            <div class="flex flex-col divide-y-2 divide-gray-200">
                                <intervention-plan-card v-for="planningInterventionGroup in contract.intervention_plan.planning_intervention_groups" :key="planningInterventionGroup.id"
                                                        :intervention-plan="planningInterventionGroup">
                                </intervention-plan-card>
                            </div>
                        </template>
                        <p v-else>Aucun type d'intervention pour ce plan d'intervention.</p>
                    </md-card-content>
                    <md-card-actions v-if="contract.intervention_plan && contract.intervention_plan.is_updating">
                        <div class="block-alert warning">
                            <p class="font-medium">Le plan d'intervention est en cours de modification. Il n'est donc pas disponible dans la planification des interventions.</p>
                        </div>
                    </md-card-actions>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
// Components
import ContractInformations from "@/pages/Contracts/components/ContractInformations";
import InterventionPlanCard from "@/pages/Contracts/InterventionPlan/components/InterventionPlanCard";

// Mixins
import routerMixin from "../../mixins/router-mixin";

export default {
    name: "ContractDetails",
    components: {
        ContractInformations, InterventionPlanCard
    },
	mixins: [routerMixin],
    data() {
        return {
            contract: {
                site: {
                    client: {}
                },
                periods: [{}],
                next_period: {},
	            current_period: {},
	            last_period: {},
                billing_months: '',
                intervention_plan: {
                    planning_intervention_groups: []
                }
            },
            tooltipActive: true
        }
    },
    methods: {
        async getContractDetails() {
            const { data } = await this.$store.dispatch('contracts/getContractDetails', { contractId: this.$route.params.contractId })
            this.contract = data
        },
        async activateInterventionPlan() {
            try {
                await this.$store.dispatch('interventionPlans/updateStateInterventionPlan', {
                    planning_intervention_id: this.contract.intervention_plan.id,
                    is_updating: false
                })
                await this.getContractDetails()
            } catch (e) {}
        },
        async goUpdateInterventionPlan(e) {
            if(!this.contract.intervention_plan.is_updating) {
                try {
                    await this.$store.dispatch('interventionPlans/updateStateInterventionPlan', {
                        planning_intervention_id: this.contract.intervention_plan.id,
                        is_updating: true
                    })
                } catch (e) {}
            }
            this.goToRoute(e, 'Intervention Plan Edit', { planningInterventionId: this.contract.intervention_plan.id })
        }
    },
    mounted() {
        this.getContractDetails()
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-layout.md-gutter {
        margin: 0;
        .md-layout-item {
            padding: 0 10px;

            &:first-child {
                padding-left: 0;
            }

            &:last-child {
                padding-right: 0;
            }
        }
    }
}
</style>
